import { action, observable, runInAction } from 'mobx';

import { ErrorInterface } from 'modules/core/api/globalApi';
import { tireDefectsController } from './tireDefectsController';
import {
  TireDefectItemInterface,
  GetTireDefectIInterface,
  InsertTireDefectInterface,
  UpdateTireDefectInterface,
  CheckBarcodeResultInterface,
} from '../../api/tireDefectsApi';

import cloneDeep from 'lodash/cloneDeep';
export interface TireDefectsStore {
  tireDefects: TireDefectItemInterface[],
  tireDefectsRequest: GetTireDefectIInterface,
  tireDefectsByOrderId: string,
  error: ErrorInterface,
}

export const tireDefectsStore: TireDefectsStore = observable({
  tireDefects: [],
  tireDefectsRequest: null,
  tireDefectsByOrderId: null,
  error: null,
} as TireDefectsStore);

const findDuplicateIndices =(arr) => {
  const indexMap = {}; // Хранит элементы как ключи и массивы индексов как значения

  for (let i = 0;i < arr.length;i++) {
    const element = arr[i];
    if (element in indexMap) {
      indexMap[element].push(i);
    } else {
      indexMap[element] = [i];
    }
  }

  // Фильтруем только элементы с двумя и более вхождениями
  // @ts-expect-error - типизацию надо сделать
  const result = Object.values(indexMap).filter((indices) => indices.length > 1);
  return result;
};

const isWrongQrCode = (barcode: string = ''): boolean => {
  const barcodeLength = barcode ? barcode.length : 0;
  if (barcodeLength > 0 && ((barcodeLength < 9) || (barcodeLength > 9))) {
    return true;
  };
  return false;
};

const saveFile =(blob, filename = 'file.pdf') => {
  // Создаем временную ссылку
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');

  // Настраиваем ссылку
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);

  // Имитируем клик для скачивания
  a.click();

  // Убираем элементы
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export const tireDefectsStoreActions = {

  newTireBlockObject: (orderId: string, storedObjectNumber: number, storedObjectRefValueId: number) => {
    return {
      orderId: orderId,
      barcode: null,
      createdByUserId: null,
      createdDate: null,
      defectTypeIds: storedObjectRefValueId===379 ? [548] : [562],
      id: `new_${ storedObjectNumber }_${ storedObjectRefValueId }`,
      storedObjectNumber: storedObjectNumber+1,
      storedObjectRefValueId,
      storedObjectRefValueName: 'Шина',
      tireTreadDepth: null,
      currentState: 'new',
      barcodeIsUniqueInDB: undefined,
      isRepeat: false,
      isWrong: false,
    };
  },

  getTireDefects: async (request:GetTireDefectIInterface): Promise<void> => {
    tireDefectsStore.error = null;
    tireDefectsStore.tireDefectsByOrderId = request.orderId;
    tireDefectsStore.tireDefectsRequest = request;
    const response = await tireDefectsController.getTireDefects(request.orderId);
    tireDefectsStoreActions.handleError(response);
    if (!response.errorData) {
      let x = response?.data?.items ?? [];
      // если данных с сервера нет, то сгенерим пустые объекты
      if (x.length ===0) {
        if ( [379,380].includes(request.storedObjectRefValueId)) {
          x = [...x, ...Array.from({ length: request.count }, (v, k) => {
            return tireDefectsStoreActions.newTireBlockObject(request.orderId, k, 379)
          } )];
        };
        if ( [380,443].includes(request.storedObjectRefValueId)) {
          x = [...x, ...Array.from({ length: request.count }, (v, k) => {
            return tireDefectsStoreActions.newTireBlockObject(request.orderId, k, 443)
          } )];
        };
      };
      runInAction(() => {
        tireDefectsStore.tireDefects = [...x];
      });
    }
  },

  setTireDefect: async (tireDefect:TireDefectItemInterface): Promise<void> => {
    const updatedTireDefect = cloneDeep(tireDefect);
    if (!updatedTireDefect.currentState || updatedTireDefect.currentState !== 'new') { updatedTireDefect.currentState = 'updated' };

    // заполним дефекты по умолчанию, если ничего не указано
    if (updatedTireDefect.defectTypeIds.length===0) {
      updatedTireDefect.defectTypeIds = updatedTireDefect.storedObjectRefValueId===379 ? [548] : [562];
    };

    // уберём "без дефектов", если есть ещё дефекты
    if (updatedTireDefect.defectTypeIds.length > 1) {
      updatedTireDefect.defectTypeIds = updatedTireDefect.defectTypeIds.filter( (v)=> ![548,562].includes(v) );
    };

    let newTireDefects: TireDefectItemInterface[] = [];
    const tireIndex= tireDefectsStore.tireDefects.findIndex((v) => v.id === tireDefect.id);
    if (tireIndex > -1) {
      newTireDefects =
      [ ...tireDefectsStore.tireDefects.filter((v)=>v.id !== tireDefect.id), updatedTireDefect ];
    }
    else
    {
      newTireDefects = [...tireDefectsStore.tireDefects, updatedTireDefect];
    }

    // проверяем, есть ли повторы QR-кодов (deepSeek подкинул функцию findDuplicateIndices)
    const x = newTireDefects.map( (v) => v.barcode);
    const y = findDuplicateIndices(x).flat();;
    newTireDefects = newTireDefects.map((v,i) => {
      return {
        ...v, isRepeat : (y.includes(i) && v.barcode) ? true : false,
      };
    });

    // проверяем формат
    newTireDefects = newTireDefects.map((v) => {
      return {
        ...v,
        isWrong: isWrongQrCode(v.barcode), // и сразу формат проверим
      };
    });

    // теперь пишем готовый массив в store
    runInAction(() => {
      tireDefectsStore.tireDefects = newTireDefects;
    });

  },

  clearTireDefects: action(() => {
    tireDefectsStore.tireDefects = [];
    tireDefectsStore.tireDefectsByOrderId = null;
    tireDefectsStore.error = null;
  }),

  saveTireDefects: async (orderId:string): Promise<void> => {
    if (tireDefectsStore?.tireDefectsByOrderId && orderId === tireDefectsStore?.tireDefectsByOrderId) {
      const x = tireDefectsStore.tireDefects.filter((v) => v.currentState === 'new');
      if (x && x.length > 0) {
        const promises = x.map(async (item) => {
          await tireDefectsStoreActions.addTireDefect(item);
        });
        await Promise.all(promises);
      };

      const y = tireDefectsStore.tireDefects.filter((v) => v.currentState === 'updated');
      if (y && y.length > 0) {
        const promisesUpdate = y.map(async (item) => {
          await tireDefectsStoreActions.updateTireDefect(item);
        });
        await Promise.all(promisesUpdate);
        await tireDefectsStoreActions.clearTireDefectsUpdated();
      };
      if (x && x.length > 0) {
        await tireDefectsStoreActions.getTireDefects(tireDefectsStore.tireDefectsRequest);
      };
    }
  },

  clearTireDefectsUpdated: action(() => {
    tireDefectsStore.tireDefects = tireDefectsStore.tireDefects.map((v) => { return { ...v, currentState: null }; });
  }),

  addTireDefect: async (request: InsertTireDefectInterface): Promise<void> => {
    const response = await tireDefectsController.addTireDefect(request);
    tireDefectsStoreActions.handleError(response);
  },

  updateTireDefect: async (request: UpdateTireDefectInterface): Promise<void> => {
    const response = await tireDefectsController.updateTireDefect(request);
    tireDefectsStoreActions.handleError(response);
  },

  checkBarcode: async (barcode :string,
    id?:string,
    isNew: boolean = false): Promise<CheckBarcodeResultInterface> =>
  {
    tireDefectsStore.error = null;
    const response = await tireDefectsController.checkBarcode(barcode, isNew ? undefined : id);
    tireDefectsStoreActions.handleError(response);
    if (!response.errorData) {
      const updatedTireDefect = tireDefectsStore.tireDefects.find((v) => v.id === id);
      updatedTireDefect.barcodeIsUniqueInDB = response?.data?.result;
      runInAction(() => {
        tireDefectsStore.tireDefects =
        [ ...tireDefectsStore.tireDefects.filter((v)=>v.id !== id), updatedTireDefect ];
      });
      return response.data;
    };
  },

  getPdfWithQRCodes: async (count: number): Promise<void> => {
    tireDefectsStore.error = null;
    const response = await tireDefectsController.getPdfWithQRCodes(count);
    tireDefectsStoreActions.handleError(response);
    if (!response.errorData) {
      saveFile(response.data, 'tireDefects.pdf');
    };
  },

  handleError: action((response) => {
    if (response.errorData) {
      const { data } = response;
      tireDefectsStore.error = data;
      throw data;
    }
  }),

};
